import { createExternalStore } from './createExternalStore';

/**
 * Assorted inbox client-only state, migrated off Apollo `makeVar` reactive vars.
 * Read reactively via `useValue()`; written imperatively via `set()`.
 */

/**
 * Transports text to SavedReplyModal to pre-fill a new saved reply.
 * useSavedReplies consumes it and resets it to '' once applied.
 */
export const createSavedReplyTextStore = createExternalStore('');

/**
 * Signals RenterProfileAttributes to scroll its section into view.
 * The section resets it to false once it has scrolled.
 */
export const shouldScrollToRenterProfileStore = createExternalStore(false);

/** Suppresses MessageList's mark-conversation-as-read behavior (e.g. after marking a conversation unread). */
export const preventMarkAsReadStore = createExternalStore(false);

/**
 * Suppresses MessageListItems' scroll-to-bottom (e.g. while a DeleteAttachments modal is open).
 * Used by inbox and lead management (RenterMessagingModal).
 */
export const preventMessageListScrollStore = createExternalStore(false);
